<template>
  <v-app>
    <v-navigation-drawer
        permanent
        color="blue lighten-5"
        app
    >
      <br>
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="https://winaero.com/blog/wp-content/uploads/2019/11/Photos-new-icon.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Leonardo Soares</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <br>

      <v-divider/>

      <v-list-item link href="/">
        <v-list-item-avatar>
          <v-icon color="black" right>mdi-alarm</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Alarms</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-navigation-drawer>

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>
